export const environment = {
  production: true,
  endpoints: {
    worldwatch: "https://api.orangecyberdefense.com/api/v1/worldwatch/",
    userpreferences: "https://api.orangecyberdefense.com/api/v1/prefs/",
    vulnerabilities: "https://api.orangecyberdefense.com/api/v1/vulns/",
    itsm: "https://api.orangecyberdefense.com/api/v1/support/",
    rss: "https://api.orangecyberdefense.com/api/v1/rss",
    okta: "https://ocd-ciam.okta.com/api/v1/",
    oktaService: "https://api.orangecyberdefense.com/api/v1/admin/",
    oktaProxyService: "https://api.orangecyberdefense.com/proxy/v1/admin/",
    fileAccess: "https://api.orangecyberdefense.com/api/v1/files/"
  },
  allowedFileTypes: [
    "image/bmp",
    "image/gif",
    "text/plain",
    "image/jpeg",
    "image/png",
    "text/csv",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/x-gzip"
  ],
  oktaConfig: {
    issuer: 'https://ocd-ciam.okta.com/oauth2/ausph0wm67FwTrmrP416',
    clientId: '0oaph1wn7Xd8Z9Gs4416',
    redirectUri: 'https://portal.orangecyberdefense.com/callback',
    adminRedirectUri: 'https://portal.orangecyberdefense.com/user/management?authd=true',
    logoutRedirectUri: 'https://portal.orangecyberdefense.com',
    baseUrl: 'https://ocd-ciam.okta.com',
  }
};